export default __webpack_public_path__ + "34f806f941c93665e93ad7ebcd78f431.png";